import BaseRepository from "../../../lib/itn-ui-kit/services/repositories/base-repository";
import AutoreferralModel from "../../models/auto-referral";

export default class AutoreferralRepository extends BaseRepository {
  static modelClass = AutoreferralModel;
  modelName = "auto-referral";
}
